import { getErrorMessage } from "@fitness-app/utils";
import { parseIncomingClientRealtimeMessage } from "@fitness-app/utils/src/chat/realtimeParsers";

import { RequestStatus } from "../../../../enums/requestStatus";
import { getLoggedUser } from "../../../helpers/getLoggedUser";
import { type AppThunk } from "../../../index";
import {
  addMessageToChannel,
  removeMessageFromChannel,
  setCurrentChannelStatus,
  subscribeToChannelFailed,
  subscribeToChannelSuccess,
  updateMessageInChannel,
  updateMessagesToMark,
} from "../reducer";

export const subscribeToChannelMessageMobile =
  (channelId: string): AppThunk =>
  async (dispatch, getState, { auth, parties, config, errorTrackingService }) => {
    try {
      const { id } = await getLoggedUser(auth);

      if (parties.chatRoomsNative[channelId]) {
        parties.chatRoomsNative[channelId]?.close();
      }
      dispatch(setCurrentChannelStatus(RequestStatus.SUBSCRIBING));

      let socket = parties.chatRoomsNative[channelId];

      if (!socket) {
        const token = (await auth.getSession())?.data?.session?.access_token;

        socket = new WebSocket(
          encodeURI(`${config.realtimeServerUrl || "localhost:1999"}/parties/chatroom/${channelId}?token=${token}`),
        );

        parties.chatRoomsNative[channelId] = socket;
      } else {
        const token = (await auth.getSession())?.data?.session?.access_token;

        socket = new WebSocket(
          encodeURI(`${config.realtimeServerUrl || "localhost:1999"}/parties/chatroom/${channelId}?token=${token}`),
        );

        parties.chatRoomsNative[channelId] = socket;
      }

      socket.addEventListener("message", (event: WebSocketEventMap["message"]) => {
        const parsedEvent = parseIncomingClientRealtimeMessage(event.data);
        if (parsedEvent.type === "initial") {
          dispatch(subscribeToChannelSuccess({ channelId }));
        }
        if (parsedEvent.type === "message") {
          if (parsedEvent.operation === "add") {
            dispatch(addMessageToChannel({ message: parsedEvent.data, channelId }));
            const { activeChannels } = getState().chat;
            const foundChannel = activeChannels.find((channel) => channel.id === channelId);
            if (foundChannel && !foundChannel.minimized) {
              dispatch(
                updateMessagesToMark({
                  messages: [parsedEvent.data].filter((item) => item.authorId !== id).map((item) => item.id),
                  channelId,
                }),
              );
            }
          }

          if (parsedEvent.operation === "delete" || (parsedEvent.operation === "update" && parsedEvent.data.deleted)) {
            dispatch(removeMessageFromChannel({ messageId: parsedEvent.data.id, channelId }));
          }

          if (parsedEvent.operation === "update" && !parsedEvent.data.deleted) {
            dispatch(updateMessageInChannel({ message: parsedEvent.data, channelId }));
          }
        }
      });

      socket.addEventListener("open", () => {
        dispatch(setCurrentChannelStatus(RequestStatus.SUBSCRIBED));
      });

      socket.addEventListener("close", () => {
        dispatch(setCurrentChannelStatus(RequestStatus.CLOSED));
      });

      socket.addEventListener("error", (error) => {
        errorTrackingService?.log("[subscribeToChannelMessageMobile]: socket error");
        dispatch(setCurrentChannelStatus(RequestStatus.FAILED));
        dispatch(subscribeToChannelFailed(getErrorMessage(error)));
      });
    } catch (error) {
      errorTrackingService?.recordError(error, "[subscribeToChannelMessageMobile]: thunk error");
      dispatch(subscribeToChannelFailed(getErrorMessage(error)));
    }
  };
